import React, { CSSProperties, useState } from 'react';
import Button from '../../../components/CustomButtons/ButtonTS';
import FileAccess from './FileAccess';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import Tooltip from "@material-ui/core/Tooltip";


type ModiFyAccessButtonProps = {
	file: any;
    fileAccounts: any;
    systemID: number;
	modifySystemFileAccess: () => void;
    setModifyAccessAlert: (alert: any) => void;
};

const buttonStyle: CSSProperties = {
	textTransform: 'uppercase',
	margin: '15px',
};

const ModiFyAccessButton = ({
    file,
    fileAccounts,
    systemID,
	modifySystemFileAccess,
    setModifyAccessAlert
}: ModiFyAccessButtonProps) => {
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);


	const showModifyFileAccess = (): any => {
		setModifyAccessAlert( 
			<SweetAlert
				title=''
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={closeWindow}
				onCancel={closeWindow}
				key='remove-system-confirmation-alert'
			>
                <FileAccess
                    file={file}
                    fileAccounts={fileAccounts}
                    systemID={systemID}
                    setModifyAccessAlert={setModifyAccessAlert}
                />
			</SweetAlert>
		);
	};

	const closeWindow = () => {
        setModifyAccessAlert(<></>);
	};

	return (
        <Tooltip title='Modify access'>
		<Button
			size='sm'
			style={buttonStyle}
			color='info'
			onClick={showModifyFileAccess}
			disabled={false}
		>
			<GroupAddOutlinedIcon/>
		</Button>
        </Tooltip>
	);
};

export default ModiFyAccessButton;
